/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ScheduledNotification } from '../models';
/**
 * ScheduledNotificationApi - axios parameter creator
 * @export
 */
export const ScheduledNotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"update\", \"Admin\"] 
         * @summary Get all scheduled notifications | Permission required: [\"update\", \"Admin\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScheduledNotifications: async (filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/scheduled-notification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduledNotificationApi - functional programming interface
 * @export
 */
export const ScheduledNotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScheduledNotificationApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"update\", \"Admin\"] 
         * @summary Get all scheduled notifications | Permission required: [\"update\", \"Admin\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllScheduledNotifications(filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduledNotification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllScheduledNotifications(filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledNotificationApi.getAllScheduledNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScheduledNotificationApi - factory interface
 * @export
 */
export const ScheduledNotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScheduledNotificationApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"update\", \"Admin\"] 
         * @summary Get all scheduled notifications | Permission required: [\"update\", \"Admin\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScheduledNotifications(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ScheduledNotification>> {
            return localVarFp.getAllScheduledNotifications(filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScheduledNotificationApi - interface
 * @export
 * @interface ScheduledNotificationApi
 */
export interface ScheduledNotificationApiInterface {
    /**
     *  **Permission required**: [\"update\", \"Admin\"] 
     * @summary Get all scheduled notifications | Permission required: [\"update\", \"Admin\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledNotificationApiInterface
     */
    getAllScheduledNotifications(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ScheduledNotification>>;

}

/**
 * ScheduledNotificationApi - object-oriented interface
 * @export
 * @class ScheduledNotificationApi
 * @extends {BaseAPI}
 */
export class ScheduledNotificationApi extends BaseAPI implements ScheduledNotificationApiInterface {
    /**
     *  **Permission required**: [\"update\", \"Admin\"] 
     * @summary Get all scheduled notifications | Permission required: [\"update\", \"Admin\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledNotificationApi
     */
    public getAllScheduledNotifications(filter?: string, options?: RawAxiosRequestConfig) {
        return ScheduledNotificationApiFp(this.configuration).getAllScheduledNotifications(filter, options).then((request) => request(this.axios, this.basePath));
    }
}

